export const INVALID_STRING_VALUES = ['', 'null'];

export const hasInvalidInput = (inputs: any[]): boolean => {
  const invalidValue = inputs.find((value) =>
    INVALID_STRING_VALUES.includes(String(value).trim()),
  );

  return invalidValue !== undefined;
};
